<template>
  <donut-modal
    v-model="isOpen"
    :cancelable="true"
    :button="null"
  >
    <div class="f-v f-ast">
      <donut-modal-sections-title title="Settings" />
      <div
        class="button inv w-100p"
        @click="onRemoveFromPulse"
      >
        Remove from Pulse
      </div>
    </div>
    <template #actions>
      <a class="link p" @click="isOpen = false">Close</a>
    </template>
  </donut-modal>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue', 'removeFromPulse']);

const isOpen = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});

const onRemoveFromPulse = () => {
  isOpen.value = false;
  emit('removeFromPulse');
};
</script>
